const INITIAL_STATE = {
  showNotes: false,
  showInterfaceNotes: false,
  typeId: null,
  objId: null,
  loading: false,
  notes: [],
  info: "",
  showHelpdesk: false,
  base64image: null,
  interfaceTypeId: null,
  interfaceObjId: null,
  interfaceLoading: false,
  interfaceNotes: [],
  helpdeskTypeId: null,
  helpdeskObjId: null,
  helpdeskAddObjId: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_SHOW_NOTES":
      return { ...state, showNotes: action.payload };
    case "SET_SHOW_INTERFACE_NOTES":
      return { ...state, showInterfaceNotes: action.payload };
    case "SET_OBJ":
      return {
        ...state,
        typeId: action.payload.typeId,
        objId: action.payload.objId
      };
    case "SET_NOTES":
      return { ...state, notes: action.payload };
    case "SET_NOTES_LOADING":
      return { ...state, loading: action.payload };
    case "SET_INTERFACE_NOTES":
      return { ...state, interfaceNotes: action.payload };
    case "SET_INTERFACE_NOTES_LOADING":
      return { ...state, interfaceLoading: action.payload };
    case "SET_NOTES_INFO":
      return { ...state, info: action.payload };
    case "SET_SHOW_HELPDESK":
      return {
        ...state,
        showHelpdesk: action.payload.helpdesk,
        base64image: action.payload.base64image,
        helpdeskTypeId: action.payload.helpdeskTypeId,
        helpdeskObjId: action.payload.helpdeskObjId,
        helpdeskAddObjId: action.payload.helpdeskAddObjId
      };
    default:
      return state;
  }
};
